<template>
  <c-modal
    :is-open="showDialog"
    :on-close="onClose"
    :close-on-overlay-click="closeOnOverlayClick"
    :size="size"
  >
    <c-modal-content
      :ref="contentRef"
      borderRadius="base"
      :px="{ base: '0', md: 'md' }"
      :py="{ base: 'xs', md: 'md' }"
      :data-cy="dataCy"
    >
      <!-- Use padding right to separate the header from the close button -->
      <c-modal-header pr="md">
        <slot name="title" />
      </c-modal-header>
      <c-modal-close-button v-if="showCloseButton" />
      <c-modal-body>
        <slot name="content" />
      </c-modal-body>
      <c-modal-footer display="flex" justify-content="center">
        <slot name="actions" />
      </c-modal-footer>
    </c-modal-content>
    <c-modal-overlay />
  </c-modal>
</template>

<script lang="ts">
import {
  CModal,
  CModalBody,
  CModalCloseButton,
  CModalContent,
  CModalFooter,
  CModalHeader,
  CModalOverlay,
} from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Modal",
  components: {
    CModal,
    CModalContent,
    CModalHeader,
    CModalBody,
    CModalFooter,
    CModalOverlay,
    CModalCloseButton,
  },
  props: {
    showDialog: {
      type: Boolean,
    },
    contentRef: {
      type: String,
    },
    dataCy: {
      type: String,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "md",
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
});
</script>
